module.exports = __webpack_public_path__ + "6ab1bed5b6b3d632a09d8f9af102032e.svg";